export default __webpack_public_path__ + "static/media/TeamTelefoon-logo-white.e47d28c1.png";